"use client";

import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableContainer,
  Paper,
  Alert,
  Button,
} from "@mui/material";
import CustomButton from "./CustomButton";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../redux/store";
import { useNavigate } from "react-router-dom";
import { logout } from "../redux/slices/authSlice";
import { clearPhoneData } from "../redux/slices/phoneSlice";
import { clearProfile } from "../redux/slices/profileSlice";

interface ProfileData {
  crbtProfile: {
    registeredName: string;
    phoneNumber: string;
    countryCode: string;
    emailId: string;
    userProfileMessage: string;
  };
}

export default function MyProfileMUI() {
  const [data, setData] = useState<any | null>(null);
  const [alertMsg, setAlertMsg] = useState<string | null>(null);

  const navigate = useNavigate();

  const { countryCode, msisdn } = useSelector(
    (state: RootState) => state.phone
  );
  const dispatch = useDispatch();

  const { planId, subType } = useSelector((state: RootState) => state.profile);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const { data } = await axios.get<ProfileData>(
          `${process.env.REACT_APP_API_URL}/Content/ProfileData?msisdn=${
            countryCode + msisdn
          }&service=${process.env.REACT_APP_SERVICE}&interface=${
            process.env.REACT_APP_INTERFACES
          }&langId=${process.env.REACT_APP_LANGID}&countryCode=${countryCode}`
        );

        setData(data?.crbtProfile);
        setAlertMsg("Profile loaded successfully!");
      } catch (error) {
        console.error(error);
        setAlertMsg("Error loading profile data");
      }
    };

    fetchProfile();
  }, [countryCode, msisdn]);

  const handleUnsubscribe = async () => {
    if (!window.confirm("Are you sure you want to Unsubscribe?")) return;

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/Purchase/Unsubscribe?msisdn=${
          countryCode + msisdn
        }&service=${process.env.REACT_APP_SERVICE}&interface=${
          process.env.REACT_APP_INTERFACES
        }&langId=${
          process.env.REACT_APP_LANGID
        }&planId=${planId}&subType=${subType}`
      );

      if (res.data.resCode === 227) {
        alert(res?.data?.resMessage);
        dispatch(logout());
        dispatch(clearPhoneData());
        dispatch(clearProfile());
        navigate("/flowtone/login");
      } else {
        alert("Unsubscribe failed: " + res.data.message);
        setAlertMsg("Unsubscribe failed: " + res.data.message);
      }
    } catch (error: any) {
      console.error(error);
      alert("Error unsubscribing: " + error.message);
      setAlertMsg("Error unsubscribing");
    }
  };

  if (!data) return <Typography>Loading...</Typography>;

  return (
    <Box sx={{ p: 3 }}>
      {/* {alertMsg && (
        <Alert
          severity={alertMsg.startsWith("Profile loaded") ? "success" : "error"}
          sx={{ mb: 3, justifyContent: "center", fontSize: "16px" }}
          onClose={() => setAlertMsg(null)}
        >
          {alertMsg}
        </Alert>
      )} */}

      <Typography variant="h4" sx={{ ml: 1, mb: 2, color: "#0085ca" }}>
        My Profile
      </Typography>

      <TableContainer
        component={Paper}
        sx={{ maxWidth: 700, borderRadius: 2, overflow: "hidden" }}
      >
        <Table>
          <TableBody>
            <TableRow>
              <TableCell width="30%">
                <Typography fontWeight="bold">Name:</Typography>
              </TableCell>
              <TableCell>{data.registeredName}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>
                <Typography fontWeight="bold">Phone number:</Typography>
              </TableCell>
              <TableCell>{msisdn}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>
                <Typography fontWeight="bold">Country Code:</Typography>
              </TableCell>
              <TableCell>{countryCode}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>
                <Typography fontWeight="bold">Email:</Typography>
              </TableCell>
              <TableCell>NA</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>
                <Typography fontWeight="bold">Account Info:</Typography>
              </TableCell>
              <TableCell>NA</TableCell>
            </TableRow>

            <TableRow>
              <TableCell></TableCell>
              <TableCell>
                <CustomButton
                  text="Unsubscribe"
                  onClick={handleUnsubscribe}
                  sx={{ textTransform: "capitalize" }}
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
